import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MMIcon from "./Icon";
import { analytics } from '../utils/analytics';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Function to close mobile menu
  const closeMobileMenu = () => {
    const navbarCollapse = document.getElementById('navbarNav');
    if (navbarCollapse && navbarCollapse.classList.contains('show')) {
      // Use Bootstrap's collapse API to close the menu
      const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
        toggle: false
      });
      bsCollapse.hide();
    }
  };

  const handleConnectClick = (e) => {
    e.preventDefault();
    analytics.navigation.headerNavigation('connect_with_me');
    closeMobileMenu();
    navigate("/", { state: { scrollTo: "contact" } });
  };

  const handleHomeClick = () => {
    analytics.navigation.headerNavigation('home');
    closeMobileMenu();
  };

  const handlePdfUnlockerClick = () => {
    analytics.navigation.headerNavigation('pdf_unlocker');
    closeMobileMenu();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        {/* Logo */}
        <Link
          to="/"
          className="navbar-brand d-flex align-items-center btn btn-link p-0 m-0"
          style={{ textDecoration: "none" }}
          onClick={handleHomeClick}
        >
          <MMIcon />
          <span className="ms-2">Mohonish Mullick</span>
        </Link>
        {/* Hamburger menu button right-aligned */}
        <button
          className="navbar-toggler ms-auto"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        {/* Menu items */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav text-end">
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
                to="/"
                onClick={handleHomeClick}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/pdf-unlocker' ? 'active' : ''}`} 
                to="/pdf-unlocker"
                onClick={handlePdfUnlockerClick}
              >
                PDF Unlocker
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact" onClick={handleConnectClick}>Connect with Me</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
